"use client";
import { filterIconAtom } from "@/hooks/headerHooks";
import {
  isEmptyFilterAtom,
  useCurrentFilters,
} from "@/hooks/useCurrentFilters";
import { useAtom } from "jotai";
import { useEffect } from "react";
import MobileFilter from "@/app/components/common-filter-builder/filter/mobile-filter/MobileFilter";
import { IFilter } from "@/api/AppApi/services/filters/interfaces/IGetFilters";

interface Props {
  productNum: number;
  filters: IFilter[];
}
const Filter: React.FC<Props> = ({ filters, productNum }) => {
  const [isEmptyFilter] = useAtom(isEmptyFilterAtom);

  const [, setShowFilterIcon] = useAtom(filterIconAtom);
  useCurrentFilters(filters);
  useEffect(() => {
    setShowFilterIcon(productNum > 0 || !isEmptyFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productNum, isEmptyFilter]);
  return (
    <>
      <MobileFilter />
    </>
  );
};

export default Filter;
